import { render } from "./ChipsSkeleton.vue?vue&type=template&id=cde7127c&scoped=true"
import script from "./ChipsSkeleton.vue?vue&type=script&lang=js"
export * from "./ChipsSkeleton.vue?vue&type=script&lang=js"

import "./ChipsSkeleton.vue?vue&type=style&index=0&id=cde7127c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde7127c"]])

export default __exports__